import { useEffect } from 'react'

const HREF =
  'https://fonts.googleapis.com/css2' +
  '?family=Instrument+Serif:ital@0;1' +
  '&family=Inter+Tight:wght@400;500;600' +
  '&family=JetBrains+Mono:wght@400;500' +
  '&display=swap'
const LINK_ID = 'sprint-packet-fonts'

export function usePacketFonts() {
  useEffect(() => {
    if (document.getElementById(LINK_ID)) return
    const link = document.createElement('link')
    link.id = LINK_ID
    link.rel = 'stylesheet'
    link.href = HREF
    document.head.appendChild(link)
  }, [])
}
